import { Link } from '@remix-run/react';
// will remove later. temporary adding it for pass eslint before commit
import React, { ComponentProps } from 'react';

export function CrossAppLink(props: ComponentProps<typeof Link>) {
    return <Link {...props} />;
}
